<template>
  <div>
    <div class="p-4 shadow" style="border-radius: 6px;">
      <h2>Welcome {{ user.first_name }}</h2>
      <hr>
      <!-- <p>{{ user.preferences2 }}</p> -->
      <!-- {{ user }} -->
      <!-- <button class="mylisting-button dark-button mt-2" @click="clearStripeID()">Clear Stripe ID</button> -->
      <button class="mylisting-button dark-button mt-1" @click="showApplicationModal()">View Application</button>
      <button class="mylisting-button dark-button mt-1" @click="showChangePasswordModal()">Change Password</button>
      <p class="mt-3" v-if="user.status == 'Applied'">Your application is pending administrator review.</p>
      <p class="mt-3" v-if="user.status == 'Application Approved'">We have reviewed your application and would be glad to help you find a Nanny for your family!</p>
      <!-- <p class="" v-if="user.status == 'Application Approved'">The next step in the process is to enter your payment inforamtion so we can start searching.</p> -->
      <!-- <p class="mt-3" v-if="user.status == 'Payment Info Entered'">Please book your interview!</p> -->
    </div>

    <!-- <div v-if="user.selector1 == 'Permanent'">
      <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Application Approved')" class="profile-tile">
        <package-selection :user="user" @userUpdated="userUpdated()"></package-selection>
      </div>
    </div> -->

    <!-- <div v-if="user.status == 'Application Approved' && !user.stripe_customer_id" class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;">
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">Please Enter Your Payment Information</h4>
      <p class="mt-2 mb-4">Your information is securely stored and you will only be billed when a service is completed.</p>
      <payments @subscribed="subscribed()" :email="user.email" :user="user"></payments>
      <div class="mt-2" style="margin-bottom: 40px;">
        <a href="https://www.stripe.com" target="_blank"><img src="../../../assets/img/stripe/powered_by_stripe_outline@2x.png" alt="Powered by Stripe" width="150px" style="float: right;"></a>
      </div>
    </div> -->

    <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Application Approved')">
      <documents :user="user"></documents>
    </div>

    <!-- ---- Book Interview Tile ---- -->
    <!-- <div v-if="user.status == 'Application Approved'" class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;">
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">Book Interview</h4>
      <p v-if="!user.stripe_customer_id" class="mt-2">Please enter your payment info before selecting an interview time. (:</p>
    </div> -->
    <!-- <div v-if="user.status == 'Payment Info Entered'" class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;"> -->
    <div class="p-4 shadow" style="border-radius: 6px; margin-top: 40px;">
      <h4 class="" style="font-weight: 500; margin-bottom: 0;">Book Interview</h4>
      <hr>
      <!-- <p v-if="!user.stripe_customer_id" class="mt-2">Please book an interview if you feel there is something further you'd like to tell us.</p> -->
      <p class="mt-2">Please book an interview if you feel there is something further you'd like to tell us.</p>
      <!-- Calendly link widget begin -->
      <div class="mt-4 mb-3">
        <a href="" class="mylisting-button dark-button" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/sarah-goldcoastnannies/15min'});return false;">Book a Call With Us</a>
      </div>
      <!-- Calendly link widget end -->
    </div>

    <!-- <div v-if="user.selector1 == 'Permanent'">
      <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Interview Complete')" class="profile-tile">
        <package-selection :user="user" @userUpdated="userUpdated()"></package-selection>
      </div>
    </div> -->

    <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Interview Complete')" class="profile-tile">
      <my-candidates :user="user"></my-candidates>
    </div>

    <!-- <div v-if="user.selector1 == 'Permanent' || user.selector1 == 'Interim'">
      <div v-if="statuses.indexOf(user.status) >= statuses.indexOf('Payment Info Entered')" class="profile-tile">
        <week-scheduler :user="user"></week-scheduler>
      </div>
    </div> -->

    <div v-if="user.status == 'Active'" class="profile-tile">
      <scheduler :user="user"></scheduler>
    </div>

    <div v-if="user.id && !$store.getters.isAgent">
      <feedback :user="user"></feedback>
    </div>

    <modal name="application-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <application :user="user"></application>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('application-modal')">Close</button>
        <!-- <button v-if="experience.id" class="mylisting-button danger-button" @click="deleteExperience(experience)" style="float: right;">Delete</button> -->
      </div>
    </modal>

    <modal name="change-password-modal" width="85%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5" v-if="user.id">
        <change-password @passwordchanged="passwordChanged()" :userID="user.id"></change-password>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('change-password-modal')">Cancel</button>
      </div>
    </modal>
    <modal name="password-changed-confirmation-modal" width="80%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h2>Password has been reset successfully.</h2>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('password-changed-confirmation-modal')" style="">Close</button>
      </div>
    </modal>

    <modal name="payment-info-entered-modal" width="90%" height="auto" :scrollable='true' style="z-index: 9999;">
      <div class="p-5">
        <h3>Thank you for submitting your payment information, we will now begin presenting you with nannies! Please also review and sign the Client Agency Agreement below.</h3>
        <hr>
        <button class="mylisting-button secondary-button" @click="$modal.hide('payment-info-entered-modal')">Close</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'

// import Application from '../../agents/ApplicationView'
import Application from '../applications/ApplicationView'
import Payments from './Payments'
import ChangePassword from '../../general/ChangePassword'
import PackageSelection from './PackageSelection'
import Documents from '../documents/Documents'
import MyCandidates from './MyCandidates'
import WeekScheduler from '../jobs/WeekScheduler'
import Scheduler from '../jobs/Scheduler'

import Feedback from "../../users/Feedback"

export default {
  props: ['userID'],
  components: {
    Application,
    Payments,
    ChangePassword,
    PackageSelection,
    Documents,
    MyCandidates,
    WeekScheduler,
    Scheduler,

    Feedback,
  },
  data() {
    return {
      user: {},
      statuses: [],
    }
  },
  created() {
    this.getUser()
    this.statuses = this.$store.getters.employerStatuses
  },
  methods: {
    getUser() {
      axios.get('/api/people/?id='+this.userID)
        .then(res => {
          // console.log(res)
          this.user = res.data[0]
        })
        .catch(error => console.log(error))
    },
    showApplicationModal() {
      this.$modal.show('application-modal')
    },
    subscribed() {
      //
      // Triggered when payment info entered
      //

      // https://www.npmjs.com/package/vue-loading-overlay
      let loader = this.$loading.show({
        // Optional parameters
        // container: this.fullPage ? null : this.$refs.formContainer,
        container: this.$refs.formContainer,
        // canCancel: true,
        canCancel: false,
        // onCancel: this.onCancel,
      });
      // simulate AJAX
      setTimeout(() => {
        loader.hide()
        // this.$emit('subscribed')
      },2000)

      axios.patch('/api/people/'+this.user.id.toString()+'/', {
        status: 'Payment Info Entered',
      })
        .then(res => {
          console.log(res)

          this.getUser()
          this.$modal.show('payment-info-entered-modal')
        })
        .catch(error => {
          console.log(error)
        })
      // this.getUser()
      // this.$modal.show('payment-info-entered-modal')
    },
    clearStripeID() {
      axios.patch('/api/people/'+this.user.id.toString()+'/', {
        stripe_customer_id: '',
        // stripe_customer_id: 'acct_1GDYUZIcCA8L7IlD',
      })
        .then(res => {
          console.log(res)
        })
        .catch(error => {
          console.log(error)
        })
    },
    showChangePasswordModal() {
      this.$modal.show('change-password-modal')
    },
    passwordChanged() {
      this.$modal.hide('change-password-modal')
      this.$modal.show('password-changed-confirmation-modal')
    },
    userUpdated() {
      this.getUser()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/employers/profile/Profile.vue